var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "10",
        viewBox: "0 0 18 10",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M2.5 6.75C2.08579 6.75 1.75 7.08579 1.75 7.5C1.75 7.91421 2.08579 8.25 2.5 8.25C2.91421 8.25 3.25 7.91421 3.25 7.5C3.25 7.08579 2.91421 6.75 2.5 6.75ZM0.25 7.5C0.25 6.25736 1.25736 5.25 2.5 5.25C3.74264 5.25 4.75 6.25736 4.75 7.5C4.75 8.74264 3.74264 9.75 2.5 9.75C1.25736 9.75 0.25 8.74264 0.25 7.5Z",
          fill: "#8796AF",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M11.5 5.75C11.0858 5.75 10.75 6.08579 10.75 6.5C10.75 6.91421 11.0858 7.25 11.5 7.25C11.9142 7.25 12.25 6.91421 12.25 6.5C12.25 6.08579 11.9142 5.75 11.5 5.75ZM9.25 6.5C9.25 5.25736 10.2574 4.25 11.5 4.25C12.7426 4.25 13.75 5.25736 13.75 6.5C13.75 7.74264 12.7426 8.75 11.5 8.75C10.2574 8.75 9.25 7.74264 9.25 6.5Z",
          fill: "#8796AF",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M6.5 1.49707C6.08579 1.49707 5.75 1.83286 5.75 2.24707C5.75 2.66128 6.08579 2.99707 6.5 2.99707C6.91421 2.99707 7.25 2.66128 7.25 2.24707C7.25 1.83286 6.91421 1.49707 6.5 1.49707ZM4.25 2.24707C4.25 1.00443 5.25736 -0.00292969 6.5 -0.00292969C7.74264 -0.00292969 8.75 1.00443 8.75 2.24707C8.75 3.48971 7.74264 4.49707 6.5 4.49707C5.25736 4.49707 4.25 3.48971 4.25 2.24707Z",
          fill: "#8796AF",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M15.5 1.75C15.0858 1.75 14.75 2.08579 14.75 2.5C14.75 2.91421 15.0858 3.25 15.5 3.25C15.9142 3.25 16.25 2.91421 16.25 2.5C16.25 2.08579 15.9142 1.75 15.5 1.75ZM13.25 2.5C13.25 1.25736 14.2574 0.25 15.5 0.25C16.7426 0.25 17.75 1.25736 17.75 2.5C17.75 3.74264 16.7426 4.75 15.5 4.75C14.2574 4.75 13.25 3.74264 13.25 2.5Z",
          fill: "#8796AF",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M6.14928 3.76274L3.87122 6.73865L2.76727 5.86777L5.04533 2.89186L6.14928 3.76274Z",
          fill: "#8796AF",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M9.955 6.00395L7.05404 3.54042L7.95668 2.44336L10.8576 4.90688L9.955 6.00395Z",
          fill: "#8796AF",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M14.9457 4.09053L13.0283 5.97432L11.9771 4.9043L13.8945 3.02051L14.9457 4.09053Z",
          fill: "#8796AF",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }